import variables from '@ingka/variables/colours-css';

export default {
  background: {
    alternative: `${variables.colourNeutral3}`,
    accent: `${variables.colourStaticIkeaBrandBlue}`,
    default: `${variables.colourNeutral1}`,
  },
  icon: {
    default: `${variables.colourTextAndIcon1}`,
  },
  neutral: {
    white: `${variables.colourNeutral1}`,
    grey100: `${variables.colourNeutral2}`,
    grey200: `${variables.colourNeutral3}`,
    grey300: `${variables.colourNeutral4}`,
    grey500: `${variables.colourNeutral5}`,
  },
  text: {
    default: `${variables.colourTextAndIcon2}`,
    black: `${variables.colourTextAndIcon1}`,
    grey4: `${variables.colourTextAndIcon4}`,
  },
  static: {
    white: `${variables.colourStaticWhite}`,
    ikeaBlue: `${variables.colourStaticIkeaFamily}`,
  },
  semantic: {
    positive: `${variables.colourSemanticPositive}`,
  },
};
